<template>
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div
          class="container-fluid d-flex flex-stack"
          id="kt_toolbar_container"
        >
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link
                    :to="{ name: 'dashboard' }"
                    class="text-muted text-hover-primary"
                  >
                    <i class="fad fa-user"></i>
                    {{ trans("Restrictions du partenaire") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>

          <b-button class="btn btn-primary" @click="applyAll">
            <i class="fad fa-check"></i>
            {{ trans("  Appliquer sur tout les sous agences") }}
          </b-button>
        </div>
      </div>
    </template>
    <template #content>
      <div>
        <h1>
          {{ trans(" Parametres d'autorisation") }}
        </h1>

        <b-tabs
          active-nav-item-class=""
          active-tab-class=""
          nav-wrapper-class="bg-white px-10  rounded-bottom nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5
                                                          fw-bolder flex-nowrap flex-grow-1"
        >
          <b-tab
            :title-link-class="'nav-link text-active-primary py-5'"
            v-for="category in categories"
            :key="category.id"
          >
            <template #title>
              <div
                class="d-flex align-items-center"
                @click="updateCategory(category)"
              >
                <!-- <i class="fad fa-users fs-2 me-2"></i> -->
                {{ category.label }}
              </div>
            </template>

            <template #default>
              <div class="p-5">
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    @change="toggleAuthorisation('categories', category.id)"
                    class="form-check-input h-30px w-50px"
                    type="checkbox"
                    :checked="verifyAuthorisation('categories', category.id)"
                  />

                  <label class="ms-2 fw-bold">
                    Autorisez la categorie {{ category.label }}</label
                  >
                </div>
              </div>

              <b-tabs
                active-nav-item-class=""
                active-tab-class=""
                nav-wrapper-class="bg-white px-10 rounded-bottom nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5
                                                          fw-bolder flex-nowrap flex-grow-1"
              >
                <b-tab
                  :title-link-class="'nav-link text-active-primary py-5'"
                  v-for="branch in category.branches"
                  @click="updateBranch(branch)"
                  :key="'branch_' + branch.id"
                >
                  <template #title>
                    <div class="d-flex align-items-center">
                      {{ branch.label }}
                    </div>
                  </template>
                  <template #default>
                    <div class="p-5">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          @change="toggleAuthorisation('branchs', branch.id)"
                          class="form-check-input h-30px w-50px"
                          type="checkbox"
                          value=""
                          :checked="verifyAuthorisation('branchs', branch.id)"
                        />

                        <label class="ms-2 fw-bold">
                          Autorisez la branche {{ branch.label }}</label
                        >
                      </div>
                    </div>

                    <div class="mb-2 card">
                      <h2 class="card-title m-3">Formulaires</h2>
                      <div class="card-body d-flex flex-wrap">
                        <template v-for="survey in getSurveys(branch)">
                          <div
                            :key="survey.id"
                            class="form-check form-switch form-check-custom form-check-solid me-5"
                          >
                            <input
                              @change="toggleAuthorisation('survey', survey.id)"
                              class="form-check-input h-30px w-50px"
                              :checked="
                                verifyAuthorisation('survey', survey.id)
                              "
                              type="checkbox"
                              value=""
                            />
                            <span class="fw-bolder ms-3">
                              {{ survey.label }}</span
                            >
                          </div>
                        </template>
                      </div>
                    </div>

                    <b-tabs
                      active-nav-item-class=""
                      active-tab-class=""
                      nav-wrapper-class="bg-white px-10 rounded-bottom nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap flex-grow-1"
                    >
                      <b-tab
                        :title-link-class="'nav-link text-active-primary py-5'"
                        @click="updateInsurer(insurer)"
                        v-for="insurer in availableInsurers"
                        :key="'insurer-' + insurer.id"
                      >
                        <template #title>
                          <div class="d-flex align-items-center">
                            <!-- <i class="fad fa-users fs-2 me-2"></i> -->
                            {{ insurer.label }}
                          </div>
                        </template>
                        <template #default>
                          <div class="p-5">
                            <div
                              @click="
                                toggleAuthorisation('insurer', insurer.id)
                              "
                              class="form-check form-switch form-check-custom form-check-solid"
                            >
                              <input
                                class="form-check-input h-30px w-50px"
                                type="checkbox"
                                value=""
                                :checked="
                                  verifyAuthorisation('insurer', insurer.id)
                                "
                              />

                              <label class="ms-2 fw-bold">
                                Autorisez l'assureur {{ insurer.label }}</label
                              >
                            </div>
                          </div>
                        </template>
                      </b-tab>
                    </b-tabs>
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex flex-wrap">
                          <div :key="index" v-for="(pack, index) in packs">
                            <div
                              class="form-check form-switch form-check-custom form-check-solid me-5"
                            >
                              <input
                                @change="toggleAuthorisation('pack', pack.id)"
                                class="form-check-input h-30px w-50px"
                                :checked="verifyAuthorisation('pack', pack.id)"
                                type="checkbox"
                                value=""
                              />
                              <span class="fw-bolder ms-3">
                                {{ pack.label }}</span
                              >
                            </div>
                          </div>
                        </div>

                        <!-- <div class="d-flex justify-content-between mb-5">
                        <div>
                          <input type="text" class="form-control" v-model="search" placeholder="Rechercher">
                        </div>
                        <div class="form-check form-switch form-check-custom form-check-solid ">
                          <label class="me-5 fs-5" v-if="!all">Tout cocher</label>
                          <label class="me-5 fs-5" v-else>Tout décocher</label>
                          <input @change="toggleAll" class="form-check-input h-30px w-50px" type="checkbox" v-model="all"
                            value="" />
                        </div>
                      </div>
                      <table class="table table-striped table-head-custom table-vertical-center gx-5">
                        <thead>
                          <tr>
                            <th></th>
                            <th v-for="pack in packs" class="text-uppercase fw-bolder">
                              {{ pack.label }}




                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="partner in partners">
                            <tr :key="partner.id" class="border-top-1"
                              v-if="empty(search) || (partner.name && partner.name.toLowerCase().includes(search.toLowerCase()) || partner.code.toLowerCase().includes(search.toLowerCase()))">
                              <td class="mw-150px">
                                <div>
                                  {{ partner.name }}
                                </div>
                                <div class="text-muted fs-8">
                                  {{ partner.code }}
                                </div>
                              </td>
                              <td v-for="pack in packs">
                                <div class="form-check form-switch form-check-custom form-check-solid ">
                                  <input @change="toggle(pack, partner)" class="form-check-input h-30px w-50px"
                                    :checked="isChecked(pack, partner)" type="checkbox" value="" />
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table> -->
                      </div>
                    </div>
                  </template>
                </b-tab>
              </b-tabs>
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <div class="mt-5">
        <h1>
          {{ trans("Parametre du menu") }}
        </h1>

        <b-tabs
          active-nav-item-class=""
          active-tab-class=""
          nav-wrapper-class="bg-white px-10  rounded-bottom nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5
                                                          fw-bolder flex-nowrap flex-grow-1"
        >
          <b-tab
            :title-link-class="'nav-link text-active-primary py-5'"
            v-for="(route, index) in routes"
            :key="index"
          >
            <template #title>
              <div
                class="d-flex align-items-center"
                @click="updateRoute(route)"
              >
                <!-- <i class="fad fa-users fs-2 me-2"></i> -->
                {{ route.label }}
              </div>
            </template>

            <template #default>
              <div class="p-5">
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    @change="toggleAuthorisation('routes', route.path)"
                    class="form-check-input h-30px w-50px"
                    type="checkbox"
                    :checked="verifyAuthorisation('categories', route.path)"
                  />

                  <label class="ms-2 fw-bold">
                    Autorisez la route parente {{ route.label }}</label
                  >
                </div>
              </div>

              <div class="card">
                <div class="d-flex flex-wrap card-body">
                  <div :key="index" v-for="(submenu, index) in route.subMenus">
                    <div
                      class="form-check form-switch form-check-custom form-check-solid me-5"
                    >
                      <input
                        @change="toggleAuthorisation('submenu', submenu.path)"
                        class="form-check-input h-30px w-50px"
                        :checked="verifyAuthorisation('submenu', submenu.path)"
                        type="checkbox"
                        value=""
                      />
                      <span class="fw-bolder ms-3"> {{ submenu.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <div class="mt-5">
        <h1>
          {{ trans("Parametre du vue de cotation") }}
        </h1>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ trans("Parametre de la recherche") }}</h3>
          </div>

          <div class="d-flex flex-wrap card-body">
            <div :key="index" v-for="(item, index) in searchItemCotation">
              <div
                class="form-check form-switch form-check-custom form-check-solid me-5 mb-3"
              >
                <input
                  @change="toggleAuthorisation('searchKeyCotation', item)"
                  class="form-check-input h-30px w-50px"
                  :checked="verifyAuthorisation('searchKeyCotation', item)"
                  type="checkbox"
                  value=""
                />
                <span class="fw-bolder ms-3"> {{ item }}</span>
              </div>
            </div>
          </div>

          <div class="card-header">
            <h3 class="card-title">{{ trans("Parametre de la liste") }}</h3>
          </div>

          <div class="d-flex flex-wrap card-body">
            <div :key="index" v-for="(item, index) in listItemsCotation">
              <div
                class="form-check form-switch form-check-custom form-check-solid me-5 mb-3"
              >
                <input
                  @change="toggleAuthorisation('listKeyCotation', item)"
                  class="form-check-input h-30px w-50px"
                  :checked="verifyAuthorisation('listKeyCotation', item)"
                  type="checkbox"
                  value=""
                />
                <span class="fw-bolder ms-3"> {{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <h1>
          {{ trans("Parametre du vue des contrats") }}
        </h1>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ trans("Parametre de la recherche") }}</h3>
          </div>

          <div class="d-flex flex-wrap card-body">
            <div :key="index" v-for="(item, index) in searchItemContract">
              <div
                class="form-check form-switch form-check-custom form-check-solid me-5 mb-3"
              >
                <input
                  @change="toggleAuthorisation('searchKeyContract', item)"
                  class="form-check-input h-30px w-50px"
                  :checked="verifyAuthorisation('searchKeyContract', item)"
                  type="checkbox"
                  value=""
                />
                <span class="fw-bolder ms-3"> {{ item }}</span>
              </div>
            </div>
          </div>

          <div class="card-header">
            <h3 class="card-title">{{ trans("Parametre de la liste") }}</h3>
          </div>

          <div class="d-flex flex-wrap card-body">
            <div :key="index" v-for="(item, index) in listItemsContract">
              <div
                class="form-check form-switch form-check-custom form-check-solid me-5 mb-3"
              >
                <input
                  @change="toggleAuthorisation('listKeyContract', item)"
                  class="form-check-input h-30px w-50px"
                  :checked="verifyAuthorisation('listKeyContract', item)"
                  type="checkbox"
                  value=""
                />
                <span class="fw-bolder ms-3"> {{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Base>
</template>


<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import { api } from "@/services/Api";
import Partner from "@/entity/Partner";
import Popup from "@/entity/Popup";
import Insurer from "@/entity/Insurer";
import BranchCategory from "@/entity/BranchCategory";
import Pack from "@/entity/Pack";
import Branch from "@/entity/Branch";
import Survey from "@/entity/Survey";

@Component({
  components: { Base },
})
export default class PartnerPackRestriction extends Vue {
  all = false;
  search = "";

  async toggleAll(event: any) {
    const res = await api.get(
      api.core,
      "partner/toggle/branch/packs/" +
        this.branch.slug +
        "/" +
        this.insurer.id +
        "/" +
        event.target.checked
    );
    console.log(res);
    this.loadPartners();
  }

  async toggle(pack: any = null, partner: any = null) {
    console.log("object");
    const res = await api.get(
      api.core,
      "partner/toggle/pack/restriction/" + partner.id + "/" + pack.id
    );
    if (res && res.data && res.data.allowed && partner instanceof Partner) {
      partner.allowedPacks = res.data.allowed;
    }
  }

  isChecked(pack: Pack, partner: Partner) {
    const allowedPacks = Array.isArray(partner.allowedPacks) ? partner.allowedPacks : [];
    return allowedPacks.includes(pack.id);
  }

  routes: any = null;

  filterMenuByRole(items: any[], roleCode: any) {
    return items.reduce((filtered, item) => {
      // Filtre récursif des sous-menus
      const sub = Array.isArray(item.subMenus)
        ? this.filterMenuByRole(item.subMenus, roleCode)
        : [];

      // Vérifie si l’item a directement le rôle ou s’il a des sous-menus valides
      const hasRole =
        Array.isArray(item.roles) &&
        item.roles.some(
          (group: any) =>
            Array.isArray(group) && group.some((r) => r.code === roleCode)
        );

      if (hasRole || sub.length > 0) {
        // Construit une copie de l’item en n’incluant que les sous-menus filtrés
        const newItem = { ...item };
        if (sub.length > 0) newItem.subMenus = sub;
        else delete newItem.subMenus; // ou newItem.subMenus = []
        filtered.push(newItem);
      }

      return filtered;
    }, []);
  }

  partners: Partner[] = [];
  insurers: Insurer[] = [];
  availableInsurers: Insurer[] = [];
  categories: BranchCategory[] = [];
  packs: Pack[] = [];
  category: any = null;
  branch: any = null;
  insurer: any = null;

  async mounted() {
    this.loadPartners();
    this.loadInsurers();
    this.loadBranches();

    // Charger les menus depuis le store (toujours disponible) ou fallback localStorage
    const storeMenus = this.$store.state.mainStore.menus;
    if (storeMenus && storeMenus.length > 0) {
      this.routes = this.filterMenuByRole(JSON.parse(JSON.stringify(storeMenus)), "ROLE_PARTNER");
    } else {
      const routes = localStorage.getItem("menus");
      if (routes) {
        this.routes = this.filterMenuByRole(JSON.parse(routes), "ROLE_PARTNER");
      }
    }
  }

  parameters: any = {};

  searchItemCotation: any = [
    "Branche",
    "Formulaires",
    "Gestionnaire",
    "Agences",
    "Agents",
    "Reponse",
    "Periode",
    "LevelCompleted",
    "Uuid",
    "Perpage",
    "Status",
    "Qualification",
  ];

  listItemsCotation: any = [
    "Cotation",
    "Prospect",
    "Valeur",
    "Agences",
    "Agents",
    "Status",
    "Surprime",
  ];

  searchItemContract: any = [
    "Branche",
    "Status",
    "Assureur",
    "Souscripteur",
    "Uuid",
    "PolicyNumber",
    "Apporteur",
    "Gestionnaire",
    "effectiveDate",
    "endDate",
    "createdDate",
    "Objet",
    "Propriété",
    "Valeur",
  ];

  listItemsContract: any = [
    "Police",
    "Actif",
    "Souscripteur",
    "Emission",
    "Durée",
    "Status/Gestionnaire",
    "Apporteur",
    "Prime TTC",
    "Actions",
    "Signed",
  ];

  toggleAuthorisation(key: string, value: any) {
    // Si la clé n’existe pas encore, on la crée avec un tableau vide
    if (this.parameters == null) {
      this.parameters = {};
    }

    // 2) Si la clé n’existe pas encore ou n’est pas un tableau, on la crée
    if (!Array.isArray(this.parameters[key])) {
      // en mode Vue 2 on ferait : this.$set(this.parameters, key, []);
      this.parameters[key] = [];
    }

    // 3) Ajout / suppression
    const arr = this.parameters[key];
    const idx = arr.indexOf(value);
    if (idx === -1) {
      arr.push(value);
    } else {
      arr.splice(idx, 1);
    }

    const res = api.post(
      api.core,
      "partner/setting/restriction/" + this.$route.params.code,
      this.parameters
    );
  }

  verifyAuthorisation(key: string | number, value: any) {
    // Si la clé n’existe pas ou n’est pas un tableau, on renvoie false

    if (!this.parameters) {
      return false;
    }

    if (
      !this.parameters.hasOwnProperty(key) ||
      !Array.isArray(this.parameters[key])
    ) {
      return false;
    }
    // Renvoie true si value est dans le tableau
    return this.parameters[key].includes(value);
  }

  updateInsurer(insurer: Insurer) {
    this.insurer = insurer;
    this.loadPacks();
  }

  updateBranch(branch: Branch) {
    this.branch = branch;
    this.loadPacks();
  }

  updateCategory(category: BranchCategory) {
    this.category = category;
    if (category.branches.length > 0) {
      this.branch = category.branches[0];
    }
    this.loadPacks();
  }

  loadPacks() {
    if (this.category && this.branch && this.insurer) {
      this.packs = [];
      this.availableInsurers = [];
      this.insurers.forEach((i: Insurer) => {
        i.packs.forEach((p: Pack) => {
          if (
            !this.availableInsurers.includes(i) &&
            p.branchSlug === this.branch.slug
          ) {
            this.availableInsurers.push(i);
          }
        });
        if (i.id === this.insurer.id) {
          i.packs.forEach((p: Pack) => {
            if (p.branchSlug === this.branch.slug) {
              this.packs.push(p);
            }
          });
        }
        let unchecked = false;

        for (let partner of this.partners) {
          const allowedPacks = Array.isArray(partner.allowedPacks) ? partner.allowedPacks : [];
          for (let pack of this.packs) {
            if (!allowedPacks.includes(pack.id)) {
              unchecked = true;
              this.all = false;
              return;
            }
          }
        }
        if (!unchecked) {
          this.all = true;
        }
      });
    }
  }

  appendPartner(partner: Partner) {
    const match = this.partners.find((p: Partner) => {
      return partner.id === p.id;
    });
    if (!match) {
      this.partners.push(partner);
    }
    partner.agencies.forEach((a: Partner) => {
      this.appendPartner(a);
    });
  }

  async loadPartners() {
    if (this.$route.params.code) {
      const res = await api.get(
        api.core,
        "partner/get/" + this.$route.params.code
      );
      if (res && res.data) {
        const p = new Partner(res.data.partner);
        this.parameters = p.parameters;
        this.appendPartner(p);
      }
    }

    // else {
    //   const res = await api.get(api.core, 'partner/top/list')
    //   if (res && res.data) {
    //     this.partners = []
    //     res.data.partners.forEach((p: Partner) => {
    //       this.partners.push(new Partner(p))
    //     })
    //   }
    // }
    this.loadPacks();
  }

  async loadInsurers() {
    const popup = new Popup(
      "Chargement des assureurs",
      "",
      "warning",
      "fad fa-cogs",
      true
    );
    const res = await api.get(api.core, "insurer/list");
    if (res && res.data && res.data.insurers) {
      this.insurers = [];
      res.data.insurers.forEach((i: Insurer) => {
        this.insurers.push(new Insurer(i));
      });
      if (this.insurers.length > 0) {
        this.insurer = this.insurers[0];
      }
    }
    popup.hide();
    this.loadPacks();
  }

  async loadBranches() {
    const pop = new Popup(
      "Chargement",
      "Liste des branches",
      "primary",
      "fad fa-sync",
      true
    );
    const res = await api.get(api.core, "branch/category/list");
    if (res && res.data && res.data.categories) {
      this.categories = [];
      res.data.categories.forEach((cat: BranchCategory) => {
        this.categories.push(new BranchCategory(cat));
      });
    }
    if (this.categories.length > 0 && this.category === null) {
      this.category = this.categories[0];
      if (this.category.branches.length > 0) {
        this.branch = this.category.branches[0];
      }
    }
    pop.hide();
    this.loadPacks();
    this.loadSurveys();
  }

  surveys: Survey[] = [];
  async loadSurveys() {
    const res = await api.get(api.form, "api/get/surveys/comparateur");
    if (res && res.data && res.data.surveys) {
      this.surveys = [];
      res.data.surveys.forEach((s: Survey) => {
        const occ = new Survey(s);
        this.surveys.push(occ);
      });
    }
  }

  getSurveys(branch: Branch) {
    const surveys: Survey[] = [];
    this.surveys.forEach((s: Survey) => {
      if (s.branch === branch.slug) {
        surveys.push(s);
      }
    });
    return surveys;
  }

  orderByInsurer() {}

  orderByCategory() {}

  async applyAll() {

    const popup = new Popup(
      "Mise à jour",
      "Mise à jour des paramètres au sous agences",
      "primary",
      "fad fa-sync",
      true
    );


    const res = await api.post(api.core, "partner/setting/restriction/apply-all-agencies/" + this.$route.params.code, this.parameters);
    if (res && res.data) {
      this.loadPartners();
    }
    

    popup.hide();
  }
    
  
}
</script>


<style scoped></style>
